/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import formatMessage from '../../../format-message';
export default function UnknownFileTypePanel() {
  return /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "medium"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "danger"
  }, formatMessage("Something went wrong and I don't know what to show you.")));
}